import { render, staticRenderFns } from "./ProductConfiguratorTitle.vue?vue&type=template&id=7f8540af&scoped=true"
import script from "./ProductConfiguratorTitle.vue?vue&type=script&lang=js"
export * from "./ProductConfiguratorTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8540af",
  null
  
)

export default component.exports